import React, { useRef, useState } from 'react'
import '../stylings/popup.css'
import { MdCancel } from 'react-icons/md'
import dummy from '../assest/dummy-popup.jpeg'
import { Link } from 'react-router-dom'
import { FaCircleChevronLeft, FaCircleChevronRight } from 'react-icons/fa6'

const Popup = ({ onClose, data }) => {

    const modalRef = useRef()
    const closeModal = (e) => {
        if (modalRef.current === e.target) {
            onClose();
        }
    }

    const [slideIndex, setSlideIndex] = useState(1)

    const handlePrev = () => {
        if (slideIndex !== 1) {
            setSlideIndex(slideIndex - 1)
        }
        else if (slideIndex === 1) {
            setSlideIndex(data.length)
        }
    }

    const handleNext = () => {
        if (slideIndex !== data.length) {
            setSlideIndex(slideIndex + 1)
        }
        else if (slideIndex === data.length) {
            setSlideIndex(1)
        }
    }

    return (
        <div ref={modalRef} onClick={closeModal} className='popup-container'>
            <div className='popup-wrapper'>
                <MdCancel className='close-svg' onClick={onClose} />
                {
                    data?.map((item, index) => (
                        <div className={slideIndex === index + 1 ? 'popup-body-wrapper active' : 'popup-body-wrapper'}>
                            <div className="popup-header mb-2 text-center">
                                <h6>{item.title}</h6>
                            </div>
                            <div className="img-container">
                                <img src={item.attachments[0].path} alt="" />
                            </div>
                            <div className="action-wrapper">
                                <p>{item.body}</p>
                            </div>
                            {
                                item.iscta &&
                                <div className="action-wrapper d-flex justify-content-end">
                                    <Link to={item.ctaurl} target='_blank'><button>{item.ctaname}</button></Link>
                                </div>
                            }
                        </div>
                    ))
                }
                {
                    data?.length > 1 &&
                    <div className="svg-container">
                        <FaCircleChevronLeft className='aarow-svg left' onClick={handlePrev} />
                        <FaCircleChevronRight className='aarow-svg right' onClick={handleNext} />
                    </div>
                }
            </div>
        </div>
    )
}

export default Popup
